import { SensorConsolidatedMethod } from 'app/shared/model/enumerations/sensor-consolidated-method.model';

export interface ISensor {
  id?: number;
  name?: string | null;
  description?: string | null;
  unit?: string | null;
  sensorConsolidatedMethod?: SensorConsolidatedMethod | null;
  clusterName?: string | null;
}

export const defaultValue: Readonly<ISensor> = {};
